import './adjacent_control_bar.scss';
import { h } from 'preact';
import { accessible } from 'utilities/accessibility';
import { IoMdResize, IoIosClose } from 'react-icons/io';

export const ControlBar = ({ onExpand, onCollapse, children, styles={} }) => {

    return (
        <div className="control-bar" style={ styles.controlBar }>
            <IoIosClose className="close-icon" aria-label="Collapse" onClick={ onCollapse }{ ...accessible(onCollapse) }  style={ styles.controlBarCollapseButton }/>
            <IoMdResize className="resize-icon" aria-label="Expand" onClick={ onExpand } { ...accessible(onExpand) } style={ styles.controlBarExpandButton }/>
            { children }
        </div>
    )
}